import React from 'react';
import './Footer.css';


const Footer = () => {
  return (
    <div className="footer">
        <div className="f-content">
            <span draggable={false}><a href='mailto:ausnermiranda@gmail.com'>ausnermiranda@gmail.com</a></span>
            <div className="f-icons">
                <span>All Rights Reserved {new Date().getFullYear()}</span>
            </div>
        </div>
    </div>
  )
}

export default Footer
